import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/web.timers.js";
import WebpPicture from '~/components/WebpPicture.vue';
export default {
  /**
   * @todo:
   * 1. Faster detection of enterd user
   * 2. Add animation
  */

  components: {
    WebpPicture: WebpPicture
  },
  props: ['room', 'wide', 'title', 'labelClass'],
  data: function data() {
    return {
      online: {},
      viewers: 1,
      maxLength: 4
    };
  },
  computed: {
    users: function users() {
      var online = [];
      var ids = [];
      for (var key in this.online) {
        if (ids.indexOf(this.online[key].id) < 0) {
          if (this.online[key].photo.match('/image/userpic/')) {
            online.unshift(this.online[key]);
          } else {
            online.push(this.online[key]);
          }
          ids.push(this.online[key].id);
        }
      }
      return online;
    },
    showUsers: function showUsers() {
      return this.users.slice(0, this.maxLength);
    },
    usersListStore: function usersListStore() {
      return useUsersListStore();
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    if (process.client) {
      this.getViewers();
      this.interval = setInterval(function () {
        _this.getViewers();
      }, 10000);
    }
  },
  methods: {
    getViewers: function getViewers() {
      var _this2 = this;
      var params = {
        room: this.room
      };
      this.$socket.get("/user/online", params, function (resData) {
        _this2.online = Object.assign({}, resData.online);
      });
    },
    open: function open() {
      var title = this.title || this.$t('inroom.title');
      this.usersListStore.update({
        url: '/user/getinroom',
        title: title,
        params: {
          room: this.room,
          casesSocket: 'true'
        }
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  }
};